import { styled } from "@mui/material/styles";
import { Grid, Table, TableCell, TableHead, TextField } from "@mui/material";

export const StyledTable = styled(Table)({
  position: "relative",
  "& .MuiTableCell-root": {
    borderBottom: "none",
  },
});

export const ReportContainer = styled(Grid)({
  display: "flex",
  flexDirection: "column",
  gap: "10px",
  minWidth: "1000px",
});

export const Container = styled(Grid)({
  display: "flex",
  justifyContent: "space-between",
  maxHeight: "52vh",
  overflow: "auto",
  position: "relative",
});

export const Header = styled(TableCell)(({ theme }) => ({
  backgroundColor: theme.palette.background.paper,
  padding: "15px",
  borderRadius: 12,
  textAlign: "center",
  color: theme.palette.secondary.light,
}));

export const StyledTableHead = styled(TableHead)(({ theme }) => ({
  zIndex: 10,
  position: "sticky",
  top: "0",
  "& .MuiTableRow-root:last-of-type": {
    "& .MuiTableCell-root": {
      backgroundColor: theme.palette.background.default,
    },
  },
  "& .MuiTableCell-root": {
    color: theme.palette.secondary.light,
  },
}));

export const StyledTextField = styled(TextField)({
  "& input": {
    padding: "5px",
    width: "40px",
  },
  "& .MuiInputBase-root.MuiOutlinedInput-root ": {
    borderRadius: "5px",
    width: "100px",
  },
});
